import * as yup from 'yup';
import i18next from 'i18next';
import ddt from '@wix/da-ddt';

function getGallectionSearchSchema() {
  return yup.object({
    type: yup
      .string()
      .oneOf(['gallery', 'collection', 'private_collection'])
      .required(i18next.t('validation.gallectionSearch.type.required')),
    order: yup
      .string()
      .oneOf(['most-recent', 'popular'])
      .optional(),
    q: yup
      .string()
      .required(i18next.t('validation.gallectionSearch.q.required')),
    username: yup
      .string()
      .required(i18next.t('validation.gallectionSearch.username.required')),
    offset: yup
      .number()
      .min(0, i18next.t('validation.gallectionSearch.offset.min'))
      .max(50000, i18next.t('validation.gallectionSearch.offset.max'))
      .optional(),
    limit: yup
      .number()
      .min(1, i18next.t('validation.gallectionSearch.limit.min'))
      .max(120, i18next.t('validation.gallectionSearch.limit.max'))
      .optional(),
    init: yup.boolean().optional(),
  });
}

/**
 * Validates gallection search request data against the server's expected schema
 * @param data The request data to validate
 * @returns boolean indicating if the data is valid
 */
export function validateGallectionSearchRequest(data: any): boolean {
  try {
    getGallectionSearchSchema().validateSync(data);
    return true;
  } catch (error) {
    ddt.log('gallection-search-validation', 'Validation failed', {
      data,
      error: error.message,
      path: error.path,
    });
    return false;
  }
}
